<!-- src/components/Footer.vue -->
<template>
	<footer class="bg-primary text-light py-3" data-aos="fade-up">
		
	</footer>
</template>

<script setup></script>

<style scoped></style>
